import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=073c79a6&scoped=true&lang=pug"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=073c79a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c79a6",
  null
  
)

export default component.exports